import { API_AUTH } from "./common";

const CamDoApi = {
  // list: ({
  //   dateFrom,
  //   dateTo,
  //   code,
  //   customerName,
  //   address,
  //   noteTaiSan,
  //   status,
  //   debt,
  //   userName,
  //   pageIndex,
  //   pageSize,
  //   dongtungay,
  //   dongdenngay,
  // }) =>
  //   API_AUTH.get(
  //     `quanlychovay/danh-sach-cam-do?dateFrom=${dateFrom}&dateTo=${dateTo}&code=${code}&customerName=${customerName}&address=${address}
  //     &noteTaiSan=${noteTaiSan}&status=${status}&debt=${debt}&userName=${userName}&dongtungay=${dongtungay}&dongdenngay=${dongdenngay}&pageIndex=${pageIndex}&pageSize=${pageSize}`,
  //     {}
  //   ),

  list: ({
    dateFrom,
    dateTo,
    code,
    customerName,
    address,
    noteTaiSan,
    status,
    debt,
    userName,
    pageIndex,
    pageSize,
    dongtungay,
    dongdenngay,
    manhanvien,
  }) =>
    API_AUTH.get(
      `quanlychovay/danh-sach-cam-do1?dateFrom=${dateFrom}&dateTo=${dateTo}&code=${code}&customerName=${customerName}&address=${address}&noteTaiSan=${noteTaiSan}&status=${status}&debt=${debt}&userName=${userName}&dongtungay=${dongtungay}&dongdenngay=${dongdenngay}&manhanvien=${manhanvien}&pageIndex=${pageIndex}&pageSize=${pageSize}`,
      {}
    ),

  toTalCamDo: (
    dateFrom,
    dateTo,
    code,
    customerName,
    address,
    noteTaiSan,
    status,
    debt,
    userName,
    dongtungay,
    dongdenngay,
    manhanvien,
    pageIndex,
    pageSize
  ) => {
    return API_AUTH.get(
      `quanlychovay/tong-cam-do?dateFrom=${dateFrom}&dateTo=${dateTo}&code=${code}&customerName=${customerName}&address=${address}&noteTaiSan=${noteTaiSan}&status=${status}&debt=${debt}&userName=${userName}&dongtungay=${dongtungay}&dongdenngay=${dongdenngay}&manhanvien=${manhanvien}&pageIndex=${pageIndex}&pageSize=${pageSize}`,
      {}
    );
  },
  detail: (choVayId) =>
    API_AUTH.get("cho-vay/chi-tiet?choVayId=" + choVayId, {}),
  SoTaiSanThanhLy: () =>
    API_AUTH.get("quan-ly-cho-vay/so-luong-tai-san-can-thanh-ly", {}),
  addAndEdit: ({
    ChoVay,
    ListHangTheChap,
    Customer,
    IsChoDuyet = false,
    IsCopy = false,
    ChoVayThamDinhTaiSan,
    ListChoVayThuocTinhGiamTru,
  }) =>
    API_AUTH.post("quanlychovay/add-cam-do", {
      ChoVay,
      ListHangTheChap,
      Customer,
      IsChoDuyet,
      IsCopy,
      ChoVayThamDinhTaiSan,
      ListChoVayThuocTinhGiamTru,
    }),
  xemTruocLanDonglai: ({
    ChoVay,
    ListHangTheChap,
    Customer,
    IsChoDuyet = false,
    IsCopy = false,
    ChoVayThamDinhTaiSan,
    ListChoVayThuocTinhGiamTru,
  }) =>
    API_AUTH.post("quanlychovay/xem-truoc-lan-dong-lai-cam-do", {
      ChoVay,
      ListHangTheChap,
      Customer,
      IsChoDuyet,
      IsCopy,
      ChoVayThamDinhTaiSan,
      ListChoVayThuocTinhGiamTru,
    }),
  checkEditChoVay: (choVayId) =>
    API_AUTH.post(
      `quan-ly-cho-vay/kiem-tra-sua-cam-do?chovayId=${choVayId}`,
      {}
    ),

  getHangSanXuat: (loaiTaiSan) =>
    API_AUTH.get(
      `thamdinhtaisan/danh-sach-hang-san-xuat?loaiTaiSan=${loaiTaiSan}`,
      {}
    ),

  getDongSanPham: (loaiTaiSan, hangSanXuat) =>
    API_AUTH.get(
      `thamdinhtaisan/danh-sach-dong-san-pham?loaiTaiSan=${loaiTaiSan}&hangSanXuat=${hangSanXuat}`,
      {}
    ),

  getNamSanXuat: (loaiTaiSan, dongSanPham) =>
    API_AUTH.get(
      `thamdinhtaisan/danh-sach-nam-san-xuat?loaiTaiSan=${loaiTaiSan}&dongsanpham=${dongSanPham}`,
      {}
    ),

  getSanPham: (loaiTaiSan, dongSanPham, namSanXuat) =>
    API_AUTH.get(
      `thamdinhtaisan/danh-sach-san-pham?loaiTaiSan=${loaiTaiSan}&dongsanpham=${dongSanPham}&namsanxuat=${namSanXuat}`,
      {}
    ),

  chitietSanPham: (sanpham) =>
    API_AUTH.get(`thamdinhtaisan/chi-tiet-san-pham?sanphamId=${sanpham}`, {}),

  getGoiVay: () => API_AUTH.get(`thamdinhtaisan/danh-sach-goi-vay`, {}),

  getGoiVay: () => API_AUTH.get(`thamdinhtaisan/danh-sach-goi-vay`, {}),
  getGoiVayTheoLoai: (LoaiGoiVay) => API_AUTH.get(`thamdinhtaisan/danh-sach-goi-vay?LoaiGoiVay=${LoaiGoiVay}`, {}),

  chitietGoiVay: (goivayId) =>
    API_AUTH.get(`thamdinhtaisan/chi-tiet-goi-vay?goivayId=${goivayId}`, {}),

  getThongTinThuocTinhGiamTru: (sanphamId, loaitaisan) =>
    API_AUTH.get(
      `thamdinhtaisan/danh-sach-thong-tin-thuoc-tinh-giam-tru?sanphamId=${sanphamId}&loaitaisan=${loaitaisan}`,
      {}
    ),

  getThamDinhTaiSanTheoChoVay: (chovayId) =>
    API_AUTH.get(
      `thamdinhtaisan/danh-sach-tham-dinh-tai-san-theo-cho-vay?chovayId=${chovayId}`,
      {}
    ),
  getConfigCamDo: (configKey) =>
    API_AUTH.get(`quan-ly-cho-vay/config-cam-do?configKey=${configKey}`, {}),
  getPhiPhatTatToanQuaHan: (chovayID) =>
    API_AUTH.get(
      `quan-ly-cho-vay/phi-tat-toan-qua-han?chovayID=${chovayID}`,
      {}
    ),
};

export default CamDoApi;
